export enum SegmentItemPadding {
    Xs,
    Sm,
    Md,
    Lg,
    Xl,
}
